import { Component, OnInit } from '@angular/core';
import { CourseMaster } from '../model/CourseMaster.model';
import { MainserviceService } from '../service/mainservice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { FaqMaster } from '../model/FaqMaster.model';
import Player from '@vimeo/player';
import { DocumentMaster } from '../model/DocumentMaster.model';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { PredefinedMaster } from '../model/PredefinedMaster.model';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMasterModel } from '../model/FilterMasterModel';
import { CompanyDetailMaster } from '../model/CompanyDetailMaster.model';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {
  companyDetailMaster:CompanyDetailMaster = new CompanyDetailMaster();
  courseMasterTemp: CourseMaster = new CourseMaster();
  masterCourseTemp: CourseMaster = new CourseMaster();
  courseMaster: CourseMaster = new CourseMaster();
  imagecarousel: any;
  showVideo: boolean = false;
  player;
  documentMasterTemp: DocumentMaster = new DocumentMaster();
  // selectedRadio:any;
  faqMaster: FaqMaster = new FaqMaster();
  faqMasterList: FaqMaster[] = [];
  faqTempList: any[] = [];
  predefinedMaster: PredefinedMaster = new PredefinedMaster();
  sortingList: PredefinedMaster[] = [];
  selectedSortOrderPredefinedId: number;
  filterList: PredefinedMaster[] = [];
  selectedCheckbox: any[] = []
  selectedRadio: any = {}
  pageSize: number = 5;
  pageNumber: number = 0;
  courseMasterList: CourseMaster[] = [];
  tempcourseMasterList: any[] = [];
  totalRecords: number = 0;
  showbtn: boolean = true;
  showfilter: boolean = false;
  showfilter1: boolean = false;
  showDialog1: boolean = false;
  value1: boolean = false;

  constructor(private mainService: MainserviceService, private authService: AuthService, private router: Router, private sanitizer: DomSanitizer,
    private meta: Meta, private titleService: Title, public spinnerService: NgxSpinnerService) {
    this.meta.updateTag({ name: 'description', content: "Discover industry-driven courses at Edstate—your path to success in real estate. From basics to advanced, acquire essential skills for a thriving career." });
    titleService.setTitle("Edstate Courses | Real estate course");
  }

  ngOnInit() {
    this.spinnerService.show()
    this.getCourseMasterList();
    this.getCourseMasterById();
    this.getFaqList();
    this.getPredefinedList('COURSE-SORTING');
    this.getPredefinedList('COURSE-FILTER');
    this.getCompanyDetail();


    this.imagecarousel = {
      loop: false,
      autoplay: false,
      margin: 1000,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 1,
      navSpeed: 500,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }


      },
      nav: true
    }


  }

  filterCourse() {
    this.showfilter = !this.showfilter;
    this.showfilter1 = false;
  }

  filterCourse1() {
    this.showfilter1 = !this.showfilter1;
    this.showfilter = false;
  }



  getCourseMasterById() {

    // this.courseMasterTemp.courseMasterId= 1;

    this.mainService.getMasterCourse(this.masterCourseTemp).subscribe(data => {
      this.masterCourseTemp = data;
      this.spinnerService.hide()

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        // this.packageServiceList = JSON.parse(jsonString);

      }


    })


  }





  getCourseMasterList() {

    if (this.selectedSortOrderPredefinedId != undefined && this.selectedSortOrderPredefinedId != null) {
      let sortOrder = new PredefinedMaster();
      sortOrder.predefinedId = this.selectedSortOrderPredefinedId;
      this.courseMasterTemp.sortOrder = sortOrder;
    }
    this.courseMasterTemp.filtersListTemp = []
    if (this.selectedCheckbox.length > 0) {

      this.courseMasterTemp.filtersListTemp[0] = new FilterMasterModel()
      this.selectedCheckbox.forEach((element) => {
        // this.courseMasterTemp.filtersListTemp[0]=new FilterMasterModel()
        this.courseMasterTemp.filtersListTemp[0].childList.push(element)
      })
      this.courseMasterTemp.filtersListTemp[0].predefinedId = this.filterList[0].predefinedId
    }

    console.log(this.selectedRadio,'selectedradio')

    if (this.selectedRadio != null && this.selectedRadio != undefined && 
       Object.keys(this.selectedRadio).length > 0) {
        if(this.courseMasterTemp.filtersListTemp[0]!==undefined && this.courseMasterTemp.filtersListTemp[0]!==null){
          this.courseMasterTemp.filtersListTemp[1] = new FilterMasterModel()

          this.courseMasterTemp.filtersListTemp[1].childList.push(this.selectedRadio)
    
          this.courseMasterTemp.filtersListTemp[1].predefinedId = this.filterList[1].predefinedId
        }else{
          this.courseMasterTemp.filtersListTemp[0] = new FilterMasterModel()

          this.courseMasterTemp.filtersListTemp[0].childList.push(this.selectedRadio)
    
          this.courseMasterTemp.filtersListTemp[0].predefinedId = this.filterList[0].predefinedId
        }
     
    }

    console.log(this.courseMasterTemp, 'coursetemp')

    this.courseMasterTemp.isMasterCourse = false;

    this.courseMasterTemp.pageNumber = this.courseMasterTemp.pageNumber
      ? this.courseMasterTemp.pageNumber
      : this.pageNumber;
    this.courseMasterTemp.pageSize = this.courseMasterTemp.pageSize
      ? this.courseMasterTemp.pageSize
      : this.pageSize;

    this.mainService.getCourseMasterList(this.courseMasterTemp).subscribe(
      (data) => {
        this.courseMasterList = data;
        this.getCourseMasterListLength();

        // this.tempcourseMasterList=[]
        // this.courseMasterList.forEach((element,index) => {

        //   this.tempcourseMasterList.push(element);


        // })


      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  incrementPage() {

    this.courseMasterTemp.pageNumber = this.courseMasterTemp.pageNumber
    this.courseMasterTemp.pageSize = this.courseMasterTemp.pageSize + 5;


    this.getCourseMasterList();


    if (this.courseMasterTemp.pageSize >= this.totalRecords) {

      this.showbtn = false;
    }
  }


  getCourseMasterListLength() {



    this.courseMasterTemp.isMasterCourse = false;


    this.mainService.getCourseMasterListLength(this.courseMasterTemp).subscribe(data => {
      this.totalRecords = data;


    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courseMasterTemp = JSON.parse(jsonString);

      }


    })
  }


  getPredefinedList(type: string) {


    this.predefinedMaster.entityType = type;

    this.mainService.getPredefinedListByType(this.predefinedMaster).subscribe(
      (data) => {
        if (type == 'COURSE-SORTING') {
          this.sortingList = data;

          // this.courseMasterTemp.sortOrder = this.sortingList[0];
        }
        else if (type == 'COURSE-FILTER') {
          this.filterList = data;

        }




      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );

  }


  sortCourses() {
    this.courseMasterTemp.pageNumber = 0;
    this.courseMasterList = [];
    this.getCourseMasterList();
    this.showfilter = false;

  }

  resetCoursesSort() {

    this.selectedSortOrderPredefinedId = null;
    this.courseMasterTemp.sortOrder = null;
    this.courseMasterTemp.pageNumber = 0;
    this.courseMasterList = [];

    this.getCourseMasterList();
    this.showfilter = false;
  }

  filterCourses() {
    this.getCourseMasterList()
    this.showfilter1 = false;
  }
  resetCoursesSortFilter() {
    this.selectedCheckbox=[]
    this.selectedRadio=[]
    this.courseMasterTemp.filtersListTemp=[]
    this.getCourseMasterList()
    this.showfilter1 = false;
  }



  navigateMaster() {
    this.router.navigateByUrl('/master-course')
  }




  viewCourse(courseMaster: CourseMaster) {
    this.authService.setcourseMasterSession(courseMaster);

    this.router.navigateByUrl('/course-details');

  }



  getFaqList() {

    this.mainService.getFaqList(this.faqMaster).subscribe(
      (data) => {
        this.faqMasterList = data;


      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  viewDialog() {


    this.showDialog1 = true;


  }

  
  getCompanyDetail(): any {
    // this.spinnerService.show();
  
    this.mainService.getCompanyDetail(new CompanyDetailMaster()).subscribe(
      data => {
        this.companyDetailMaster = data;
        // this.spinnerService.hide();
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
         //   this.spinnerService.hide();
            let data = JSON.parse(jsonString);
            this.companyDetailMaster = data;
          } else {
            this.authService.showMessage('error','Something went wrong', '');
          //  this.spinnerService.hide();
          }
          // this.spinnerService.hide();
        }
      }
    );
  }

  closeBannerVideo() {
    this.showVideo = false;
  }

  videoDisplay() {

    this.documentMasterTemp = this.masterCourseTemp.courseBannerVideo;
    if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
      this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
    }


    this.showVideo = true;

    setTimeout(() => {
      this.initPlayer();
      this.setVideo(this.documentMasterTemp.linkId);

      this.playVideo();

    }, 500);

  }


  public initPlayer() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo(videoId: any) {

    // this.destroyPlayer();
    // this.initPlayer();


    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 1000);

  }


}
